import { Navigate, Outlet } from "react-router-dom";

export default function InterestsRoute() {
    const canAccess = sessionStorage.getItem("show_interests");
    if (!canAccess) {
        return <Navigate to="/create-account/email" replace />;
    }
    return <Outlet />;
}
